import React, { useEffect } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import LocationsContent from './LocationsContent';
import PageSEO from './PageSEO'; // Import the SEO component

const LocationsView = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Comprehensive SEO configuration for locations directory page
  const locationsSEO = {
    title: "All Locations | Kinder's Meats Deli BBQ & Catering - 6 California Restaurants",
    description: "Find your nearest Kinder's Meats BBQ restaurant! We serve authentic barbecue and premium deli meats at 6 California locations: Brentwood, Concord, Hercules, Martinez, Pleasant Hill, and both Walnut Creek locations. Hours, directions, and contact info for all locations.",
    keywords: [
      "Kinder's Meats locations",
      "BBQ restaurant locations California",
      "Kinder's Meats near me", 
      "BBQ restaurants East Bay",
      "Kinder's Meats Brentwood",
      "Kinder's Meats Concord",
      "Kinder's Meats Hercules", 
      "Kinder's Meats Martinez",
      "Kinder's Meats Pleasant Hill",
      "Kinder's Meats Walnut Creek",
      "family BBQ restaurant California",
      "BBQ restaurant directory",
      "East Bay BBQ locations",
      "California BBQ restaurant chain",
      "authentic BBQ near me",
      "deli restaurant locations",
      "BBQ restaurant hours",
      "restaurant locations map",
      "BBQ pickup and delivery",
      "barbecue restaurants California",
      "family restaurant locations",
      "6 restaurant locations",
      "multi-location BBQ restaurant"
    ],
    canonicalUrl: "/locations",
    ogImage: "https://kindersmeats.com/images/all-locations-map-og.jpg",
    customMeta: {
      'geo.region': 'CA-US',
      'geo.placename': 'California, East Bay',
      'business.locations.count': '6',
      'business.service.area': 'East Bay California'
    },
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CollectionPage",
          "@id": "https://kindersmeats.com/locations#collectionpage",
          "url": "https://kindersmeats.com/locations",
          "name": "All Locations | Kinder's Meats Deli BBQ & Catering",
          "description": "Directory of all Kinder's Meats BBQ restaurant locations across California",
          "isPartOf": {
            "@id": "https://kindersmeats.com/#website"
          },
          "about": {
            "@id": "https://kindersmeats.com/#organization"
          },
          "mainEntity": {
            "@id": "https://kindersmeats.com/locations#locationlist"
          },
          "breadcrumb": {
            "@id": "https://kindersmeats.com/locations#breadcrumb"
          }
        },
        {
          "@type": "ItemList",
          "@id": "https://kindersmeats.com/locations#locationlist",
          "name": "Kinder's Meats Restaurant Locations",
          "description": "Complete list of Kinder's Meats BBQ restaurant locations in California",
          "numberOfItems": 6,
          "itemListOrder": "Alphabetical",
          "itemListElement": [
            {
              "@type": "Restaurant",
              "position": 1,
              "name": "Kinder's Meats Brentwood",
              "url": "https://kindersmeats.com/locations/brentwood",
              "description": "Kinder's Meats BBQ restaurant in Brentwood, California",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Brentwood",
                "addressRegion": "CA",
                "addressCountry": "US"
              },
              "servesCuisine": ["BBQ", "American", "Deli"],
              "priceRange": "$$",
              "openingHours": ["Mo-Su 08:30-21:00"]
            },
            {
              "@type": "Restaurant", 
              "position": 2,
              "name": "Kinder's Meats Concord",
              "url": "https://kindersmeats.com/locations/concord",
              "description": "Kinder's Meats BBQ restaurant in Concord, California - our flagship location",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Concord",
                "addressRegion": "CA", 
                "addressCountry": "US"
              },
              "servesCuisine": ["BBQ", "American", "Deli"],
              "priceRange": "$$",
              "openingHours": ["Mo-Su 08:30-21:00"]
            },
            {
              "@type": "Restaurant",
              "position": 3,
              "name": "Kinder's Meats Hercules",
              "url": "https://kindersmeats.com/locations/hercules",
              "description": "Kinder's Meats BBQ restaurant in Hercules, California",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Hercules",
                "addressRegion": "CA",
                "addressCountry": "US"
              },
              "servesCuisine": ["BBQ", "American", "Deli"],
              "priceRange": "$$",
              "openingHours": ["Mo-Su 08:30-21:00"]
            },
            {
              "@type": "Restaurant",
              "position": 4,
              "name": "Kinder's Meats Martinez",
              "url": "https://kindersmeats.com/locations/martinez",
              "description": "Kinder's Meats BBQ restaurant in Martinez, California",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Martinez", 
                "addressRegion": "CA",
                "addressCountry": "US"
              },
              "servesCuisine": ["BBQ", "American", "Deli"],
              "priceRange": "$$",
              "openingHours": ["Mo-Su 08:30-21:00"]
            },
            {
              "@type": "Restaurant",
              "position": 5,
              "name": "Kinder's Meats Pleasant Hill",
              "url": "https://kindersmeats.com/locations/pleasant-hill",
              "description": "Kinder's Meats BBQ restaurant in Pleasant Hill, California",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Pleasant Hill",
                "addressRegion": "CA",
                "addressCountry": "US"
              },
              "servesCuisine": ["BBQ", "American", "Deli"],
              "priceRange": "$$",
              "openingHours": ["Mo-Su 08:30-21:00"]
            },
            {
              "@type": "Restaurant",
              "position": 6,
              "name": "Kinder's Meats Walnut Creek", 
              "url": "https://kindersmeats.com/locations/walnut-creek-ygnacio",
              "description": "Kinder's Meats BBQ restaurant in Walnut Creek, California",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Walnut Creek",
                "addressRegion": "CA",
                "addressCountry": "US"
              },
              "servesCuisine": ["BBQ", "American", "Deli"],
              "priceRange": "$$",
              "openingHours": ["Mo-Su 08:30-21:00"]
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://kindersmeats.com/#organization",
          "name": "Kinder's Meats Deli BBQ & Catering",
          "url": "https://kindersmeats.com", 
          "logo": {
            "@type": "ImageObject",
            "url": "https://kindersmeats.com/images/kinders-logo.png",
            "width": 300,
            "height": 100
          },
          "description": "Family-owned BBQ restaurant chain serving authentic barbecue across 6 California locations since 1946",
          "numberOfEmployees": {
            "@type": "QuantitativeValue",
            "minValue": 50,
            "maxValue": 200
          },
          "location": {
            "@id": "https://kindersmeats.com/locations#locationlist"
          },
          "areaServed": [
            {
              "@type": "City",
              "name": "Brentwood",
              "containedInPlace": {
                "@type": "State", 
                "name": "California"
              }
            },
            {
              "@type": "City",
              "name": "Concord",
              "containedInPlace": {
                "@type": "State",
                "name": "California"
              }
            },
            {
              "@type": "City",
              "name": "Hercules",
              "containedInPlace": {
                "@type": "State",
                "name": "California"
              }
            },
            {
              "@type": "City",
              "name": "Martinez",
              "containedInPlace": {
                "@type": "State",
                "name": "California"
              }
            },
            {
              "@type": "City",
              "name": "Pleasant Hill",
              "containedInPlace": {
                "@type": "State",
                "name": "California"
              }
            },
            {
              "@type": "City",
              "name": "Walnut Creek",
              "containedInPlace": {
                "@type": "State",
                "name": "California"
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://kindersmeats.com/locations#breadcrumb",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://kindersmeats.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Locations",
              "item": "https://kindersmeats.com/locations"
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "How many Kinder's Meats locations are there?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Kinder's Meats has 6 restaurant locations across California: Brentwood, Concord, Hercules, Martinez, Pleasant Hill, Walnut Creek."
              }
            },
            {
              "@type": "Question",
              "name": "What are the hours for Kinder's locations?", 
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Most Kinder's Meats locations are open Monday through Sunday from 8:30 AM to 9:00 PM. Hours may vary slightly by location, so check individual location pages for specific details."
              }
            },
            {
              "@type": "Question",
              "name": "Do all locations offer the same menu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, all Kinder's Meats locations feature the same core menu of authentic BBQ, deli sandwiches, and butcher counter specialties. Some seasonal items may vary."
              }
            },
            {
              "@type": "Question",
              "name": "Which Kinder's location is closest to me?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Use our locations page to find the Kinder's Meats restaurant nearest you. We have locations throughout the East Bay including Brentwood, Concord, Hercules, Martinez, Pleasant Hill, and two Walnut Creek locations."
              }
            },
            {
              "@type": "Question",
              "name": "Do all locations offer pickup and delivery?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, all Kinder's Meats locations offer both pickup and delivery services. You can order online or call your preferred location directly."
              }
            }
          ]
        }
      ]
    }
  };

  return (
    <>
      {/* SEO Component */}
      <PageSEO {...locationsSEO} />
      
      {/* Main content with semantic HTML structure */}
      <main>
        <section className="theme-light m-0 p-0" data-theme="light">
          <div className='is-flex is-flex-direction-column fullHeight is-justify-content-space-between'>
            <div className='is-flex is-flex-direction-column is-justify-content-start'>
              <Navigation />

              {/* Locations Directory Content */}
              <article itemScope itemType="https://schema.org/CollectionPage">
                <LocationsContent 
                    className="content-space-160 is-10-mobile is-10-tablet is-10-desktop is-10-widescreen is-8-fullhd is-offset-1-mobile is-offset-1-tablet is-offset-1-desktop is-offset-1-widescreen is-offset-2-fullhd"
                    title="Locations"
                />
              </article>

              {/* Hidden FAQ Section for SEO */}
              <section className="faq-section" style={{ display: 'none' }} aria-hidden="true" itemScope itemType="https://schema.org/FAQPage">
                <h2>Locations FAQ</h2>
                
                <div itemScope itemType="https://schema.org/Question">
                  <h3 itemProp="name">How many Kinder's Meats locations are there?</h3>
                  <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                    <div itemProp="text">
                      Kinder's Meats has 6 restaurant locations across California: Brentwood, Concord, Hercules, Martinez, Pleasant Hill, and Walnut Creek.
                    </div>
                  </div>
                </div>

                <div itemScope itemType="https://schema.org/Question">
                  <h3 itemProp="name">What are the hours for Kinder's locations?</h3>
                  <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                    <div itemProp="text">
                      Most Kinder's Meats locations are open Monday through Sunday from 8:30 AM to 9:00 PM. Hours may vary slightly by location, so check individual location pages for specific details.
                    </div>
                  </div>
                </div>

                <div itemScope itemType="https://schema.org/Question">
                  <h3 itemProp="name">Do all locations offer the same menu?</h3>
                  <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                    <div itemProp="text">
                      Yes, all Kinder's Meats locations feature the same core menu of authentic BBQ, deli sandwiches, and butcher counter specialties. Some seasonal items may vary.
                    </div>
                  </div>
                </div>

                <div itemScope itemType="https://schema.org/Question">
                  <h3 itemProp="name">Which Kinder's location is closest to me?</h3>
                  <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                    <div itemProp="text">
                      Use our locations page to find the Kinder's Meats restaurant nearest you. We have locations throughout the East Bay including Brentwood, Concord, Hercules, Martinez, Pleasant Hill, and two Walnut Creek locations.
                    </div>
                  </div>
                </div>

                <div itemScope itemType="https://schema.org/Question">
                  <h3 itemProp="name">Do all locations offer pickup and delivery?</h3>
                  <div itemScope itemType="https://schema.org/Answer" itemProp="acceptedAnswer">
                    <div itemProp="text">
                      Yes, all Kinder's Meats locations offer both pickup and delivery services. You can order online or call your preferred location directly.
                    </div>
                  </div>
                </div>
              </section>
            </div>   
            <Footer />
          </div>
        </section>
      </main>
    </>
  );
};

export default LocationsView;